import { API, Auth } from "aws-amplify";

/**
 * @typedef {{
 * config: Object
 * data: Payload
 * headers: import('axios').AxiosResponseHeaders
 * request: XMLHttpRequest
 * status: number
 * statusText: string
 * }} GETResponse<Payload>
 * @template {any} Payload
 */

/**
 * @async
 * @param {Object} params         Object parameters for API call
 * @param {string} params.method  API method
 * @param {string} params.apiName API name for call, the base path
 * @param {string} params.path    API's path to be appended to apiName
 * @param {Object} params.payload Object to be sent as request body to API
 * @param {string} params.orgId   Current user's active organization id
 */
export const callLambdaApi = async (params) => {
  const { method, apiName, path, payload = {} } = params;
  const jwt = (await Auth.currentSession()).getIdToken().getJwtToken();
  const appendedPayload = {
    ...payload,
    response: true,
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  };
  return API[method](apiName, path, appendedPayload);
};

export const callLambdaApiNoAuth = async (params) => {
  const { method, apiName, path, payload = {} } = params;
  const appendedPayload = {
    ...payload,
    response: true,
  };
  return API[method](apiName, path, appendedPayload);
};
